/* =================== VIDEOS =================== */
$(function () {
  $(".carrosel-videos").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});

$(function () {
  $(".carrosel-videos-servico").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
});

(function () {
  "use strict";

  var $modalVideo = $("#modal-video-box");
  var $btnOpenVideo = $(".btn-open-video"); // Exibe o modal do vÃ­deo ao clicar no botÃ£o

  $btnOpenVideo.on("click", function (ev) {
    ev.preventDefault();
    var $btn = $(this);
    var videoCod = $btn.data("video-cod");
    var videoPlataform = $btn.data("video-plataform");
    var videoTitle = $btn.data("video-title");

    if (videoCod != "" && videoPlataform != "" && !$btn.hasClass("disabled")) {
      $modalVideo
        .find(".bloco-video-wrapper")
        .html("")
        .append(createIframeVideo(videoCod, videoPlataform));

      if (videoTitle != "") {
        $modalVideo.find(".bloco-video-titulo").html(videoTitle).show();
      } else {
        $modalVideo.find(".bloco-video-titulo").html("").hide();
      }

      openModal("modal-video-box");
    }
  }); // Remove o vÃ­deo ao fechar o modal

  $modalVideo.on("modal-close", function () {
    $modalVideo.find(".bloco-video-wrapper").html("");
    $modalVideo.find(".bloco-video-titulo").html("").hide();
  }); // Cria um elemento Iframe de vÃ­deo

  function createIframeVideo(videoCod, videoPlataform) {
    var $iframe;

    if (videoPlataform == "youtube") {
      $iframe = '<iframe src="https://www.youtube.com/embed/'.concat(
        videoCod,
        '?controls=1&autoplay=1" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>'
      );
    } else if (videoPlataform == "vimeo") {
      $iframe = '<iframe src="https://player.vimeo.com/video/'.concat(
        videoCod,
        '?title=0&byline=0&portrait=0&autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>'
      );
    }

    return $iframe;
  }
})();
